import React from 'react'
import { useSelector } from 'react-redux'
import { ws } from '../functions/ws'
import { IDashboard } from '../models/dashboard'
import { IState } from '../models/state'

export const DashboardMain = () => {

	const brlLogo = require('../images/BRL.svg')
	const linkLogo = require('../images/LINK.svg')
	const btcLogo = require('../images/bitcoin.svg')
	const ltcLogo = require('../images/litecoin.svg')
	const dogeLogo = require('../images/dogecoin.svg')
	const ethLogo = require('../images/ethereum.svg')
	const usdcLogo = require('../images/USDC.svg')
	const ebitLogo = require('../images/ebit.svg')

	const dashboard = useSelector<IState, IDashboard>(state => state.dashboard)

	const today = new Date().toJSON().split('T')[0]
	const [period, setPeriod] = React.useState({
		initialPeriod: new Date(today + ' 00:00:00'),
		finalPeriod: new Date(today + ' 23:59:59.999')
	})

	React.useEffect(
		() => {
			ws.send({ type: 'Dashboard.Get', period } as any)
		},
		[])

	const filterPeriod = () => {
		ws.send({ type: 'Dashboard.Get', period } as any)
	}

	return (
		<div className='walletsMain'>
			<span className='pageTitle'>Dashboard</span>
			<span className='pageBoxTitle'>Period:</span>
			<div className='filterPeriod'>

				<label htmlFor='initialPeriod' >Initial:</label>
				<input name='initialPeriod' type='date' onChange={(e) => setPeriod({ ...period, initialPeriod: new Date(e.target.value + ' 00:00:00') })} defaultValue={today} />

				<label htmlFor='finalPeriod' >Final:</label>
				<input name='finalPeriod' type='date' onChange={(e) => setPeriod({ ...period, finalPeriod: new Date(e.target.value + ' 23:59:59.999') })} defaultValue={today} />

				<button name='filterPeriod' className='walletsTableButton' onClick={filterPeriod}>Filter</button>

			</div>
			<br />
			<div className='pageColumn5Box'>
				<div className='pageColumn5'>
					<span className='pageBoxTitle'>Users</span>
					<table className='walletsTableMain'>
						<thead>
							<tr className='walletsTableHeaderRow'>
								<td className='walletsTableHeaderRowItem'>Type</td>
								<td className='walletsTableHeaderRowItem'>Total</td>
							</tr>
						</thead>
						<tbody>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><span className='profileFormTag tagPurple'>Unverified</span></td>
								<td className='walletsTableBodyRowItem'>{dashboard.users.unverified}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><span className='profileFormTag tagYellow'>Pending</span></td>
								<td className='walletsTableBodyRowItem'>{dashboard.users.pending}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><span className='profileFormTag tagGreen'>Verified</span></td>
								<td className='walletsTableBodyRowItem'>{dashboard.users.verified}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><span className='profileFormTag tagRed'>Blocked</span></td>
								<td className='walletsTableBodyRowItem'>{dashboard.users.blocked}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><span className='profileFormTag tagBlack'>Admin</span></td>
								<td className='walletsTableBodyRowItem'>{dashboard.users.admin}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><span className='profileFormTag tagGrey'>Operator</span></td>
								<td className='walletsTableBodyRowItem'>{dashboard.users.operator}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className='pageColumn5'>
					<span className='pageBoxTitle'>Deposits</span>
					<table className='walletsTableMain'>
						<thead>
							<tr className='walletsTableHeaderRow'>
								<td className='walletsTableHeaderRowItem'>Coin</td>
								<td className='walletsTableHeaderRowItem'>Total</td>
							</tr>
						</thead>
						<tbody>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={brlLogo} className='walletsLogo' alt='BRL' />BRL</td>
								<td className='walletsTableBodyRowItem'>{dashboard.deposits.BRL?.toFixed(2)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={btcLogo} className='walletsLogo' alt='BTC' /> BTC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.deposits.BTC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ethLogo} className='walletsLogo' alt='ETH' /> ETH</td>
								<td className='walletsTableBodyRowItem'>{dashboard.deposits.ETH?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ebitLogo} className='walletsLogo' alt='EBIT' /> EBIT</td>
								<td className='walletsTableBodyRowItem'>{dashboard.deposits.EBIT?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ltcLogo} className='walletsLogo' alt='LTC' /> LTC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.deposits.LTC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={dogeLogo} className='walletsLogo' alt='DOGE' /> DOGE</td>
								<td className='walletsTableBodyRowItem'>{dashboard.deposits.DOGE?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={usdcLogo} className='walletsLogo' alt='USDC' /> USDC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.deposits.USDC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={linkLogo} className='walletsLogo' alt='LINK' /> LINK</td>
								<td className='walletsTableBodyRowItem'>{dashboard.deposits.LINK?.toFixed(8)}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className='pageColumn5'>
					<span className='pageBoxTitle'>Withdrawals</span>
					<table className='walletsTableMain'>
						<thead>
							<tr className='walletsTableHeaderRow'>
								<td className='walletsTableHeaderRowItem'>Coin</td>
								<td className='walletsTableHeaderRowItem'>Total</td>
							</tr>
						</thead>
						<tbody>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={brlLogo} className='walletsLogo' alt='BRL' />BRL</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawals.BRL?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={btcLogo} className='walletsLogo' alt='BTC' /> BTC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawals.BTC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ethLogo} className='walletsLogo' alt='ETH' /> ETH</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawals.ETH?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ebitLogo} className='walletsLogo' alt='EBIT' /> EBIT</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawals.EBIT?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ltcLogo} className='walletsLogo' alt='LTC' /> LTC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawals.LTC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={dogeLogo} className='walletsLogo' alt='DOGE' /> DOGE</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawals.DOGE?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={usdcLogo} className='walletsLogo' alt='USDC' /> USDC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawals.USDC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={linkLogo} className='walletsLogo' alt='LINK' /> LINK</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawals.LINK?.toFixed(8)}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className='pageColumn5'>
					<span className='pageBoxTitle'>Withdraw Fees</span>
					<table className='walletsTableMain'>
						<thead>
							<tr className='walletsTableHeaderRow'>
								<td className='walletsTableHeaderRowItem'>Coin</td>
								<td className='walletsTableHeaderRowItem'>Total</td>
							</tr>
						</thead>
						<tbody>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={brlLogo} className='walletsLogo' alt='BRL' />BRL</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawFees.BRL?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={btcLogo} className='walletsLogo' alt='BTC' /> BTC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawFees.BTC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ethLogo} className='walletsLogo' alt='ETH' /> ETH</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawFees.ETH?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ebitLogo} className='walletsLogo' alt='EBIT' /> EBIT</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawFees.EBIT?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ltcLogo} className='walletsLogo' alt='LTC' /> LTC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawFees.LTC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={dogeLogo} className='walletsLogo' alt='DOGE' /> DOGE</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawFees.DOGE?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={usdcLogo} className='walletsLogo' alt='USDC' /> USDC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawFees.USDC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={linkLogo} className='walletsLogo' alt='LINK' /> LINK</td>
								<td className='walletsTableBodyRowItem'>{dashboard.withdrawFees.LINK?.toFixed(8)}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className='pageColumn5'>
					<span className='pageBoxTitle'>Trade Fees</span>
					<table className='walletsTableMain'>
						<thead>
							<tr className='walletsTableHeaderRow'>
								<td className='walletsTableHeaderRowItem'>Coin</td>
								<td className='walletsTableHeaderRowItem'>Total</td>
							</tr>
						</thead>
						<tbody>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={brlLogo} className='walletsLogo' alt='BRL' />BRL</td>
								<td className='walletsTableBodyRowItem'>{dashboard.tradeFees.BRL?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={btcLogo} className='walletsLogo' alt='BTC' /> BTC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.tradeFees.BTC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ethLogo} className='walletsLogo' alt='ETH' /> ETH</td>
								<td className='walletsTableBodyRowItem'>{dashboard.tradeFees.ETH?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ebitLogo} className='walletsLogo' alt='EBIT' /> EBIT</td>
								<td className='walletsTableBodyRowItem'>{dashboard.tradeFees.EBIT?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={ltcLogo} className='walletsLogo' alt='LTC' /> LTC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.tradeFees.LTC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={dogeLogo} className='walletsLogo' alt='DOGE' /> DOGE</td>
								<td className='walletsTableBodyRowItem'>{dashboard.tradeFees.DOGE?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={usdcLogo} className='walletsLogo' alt='USDC' /> USDC</td>
								<td className='walletsTableBodyRowItem'>{dashboard.tradeFees.USDC?.toFixed(8)}</td>
							</tr>
							<tr className='walletsTableBodyRow'>
								<td className='walletsTableBodyRowItem'><img src={linkLogo} className='walletsLogo' alt='LINK' /> LINK</td>
								<td className='walletsTableBodyRowItem'>{dashboard.tradeFees.LINK?.toFixed(8)}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/dashboardMain.tsx